<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Combined</span>
        <h3 class="page-title">Social Inbox</h3>
      </d-col>
    </d-row>

    <!-- Editor -->
    <d-card>
      <d-card-body class="py-3">
        <d-row>
          <d-col lg="4" class="p-1 rounded-left-only mh-100">
            <messages-box/>
          </d-col>
          <d-col lg="8" class="p-1 rounded-right-only mh-100">
            <anp-chatbox/>
          </d-col>
        </d-row>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import ChatBox from "@/components/SocialInbox/ChatBox.vue";
import MessagesBox from "@/components/SocialInbox/MessagesBox.vue";

import "quill/dist/quill.snow.css";

export default {
  components: {
    anpChatbox: ChatBox,
    MessagesBox
  }
};
</script>
